import type { ProviderContextConfig } from '@openx/components-provider/lib/utils/context/ProviderContext.tsx';

import { useAccountOptionsFetch } from './utils/useAccountOptionsFetch.ts';
import { useCreateProvider } from './utils/useCreateProvider.ts';
import { useEditProvider } from './utils/useEditProvider.ts';
import { useEditProviderAllowedAccounts } from './utils/useEditProviderAllowedAccounts.ts';
import { useGetProvidersTableData } from './utils/useGetProvidersTableData.tsx';
import { useProviderFetch } from './utils/useProviderFetch.ts';
import { useProviderPageHeaderActions } from './utils/useProviderPageHeaderActions.ts';
import { useProvidersListFetch } from './utils/useProvidersListFetch.ts';

export const providerConfig: ProviderContextConfig = {
  isOa: true,
  useAccountOptionsFetch,
  useCreateProvider,
  useEditProvider,
  useEditProviderAllowedAccounts,
  useGetProvidersTableData,
  useProviderFetch,
  useProviderPageHeaderActions,
  useProvidersListFetch,
};
